export const unicodeToChar = (text: string) => {
  return text.replace(/&#[0-9]{2};/gi, function (match) {
    return String.fromCharCode(parseInt(match.replace(/\D/g, '')));
  });
};
